var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyRedemption = function SvgEmptyRedemption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271,
    height: 110,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.34,
    filter: "url(#empty-redemption_svg__a)",
    opacity: 0.61,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M46.432 11.09A3.09 3.09 0 0 1 49.522 8H162.1a3.09 3.09 0 0 1 3.089 3.09v12.648a3.09 3.09 0 0 1-3.089 3.09H49.521a3.09 3.09 0 0 1-3.09-3.09V11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__b)",
    d: "M46.432 11.09A3.09 3.09 0 0 1 49.522 8H162.1a3.09 3.09 0 0 1 3.089 3.09v12.648a3.09 3.09 0 0 1-3.089 3.09H49.521a3.09 3.09 0 0 1-3.09-3.09V11.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-redemption_svg__c)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__d)",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M162.101 8.724H49.521a2.366 2.366 0 0 0-2.365 2.366v12.648a2.365 2.365 0 0 0 2.365 2.365h112.58a2.365 2.365 0 0 0 2.365-2.365V11.09a2.365 2.365 0 0 0-2.365-2.366ZM49.521 8a3.09 3.09 0 0 0-3.09 3.09v12.648a3.09 3.09 0 0 0 3.09 3.09h112.58a3.09 3.09 0 0 0 3.089-3.09V11.09A3.09 3.09 0 0 0 162.101 8H49.521Z",
    clipRule: "evenodd",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.34,
    filter: "url(#empty-redemption_svg__e)",
    opacity: 0.61,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M10.225 45.504a3.09 3.09 0 0 1 3.09-3.09h244.372a3.09 3.09 0 0 1 3.089 3.09v12.648a3.09 3.09 0 0 1-3.089 3.09H13.314a3.09 3.09 0 0 1-3.09-3.09V45.504Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__f)",
    d: "M10.225 45.504a3.09 3.09 0 0 1 3.09-3.09h244.372a3.09 3.09 0 0 1 3.089 3.09v12.648a3.09 3.09 0 0 1-3.089 3.09H13.314a3.09 3.09 0 0 1-3.09-3.09V45.504Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-redemption_svg__g)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__h)",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M257.687 43.138H13.314a2.365 2.365 0 0 0-2.365 2.366v12.648a2.366 2.366 0 0 0 2.365 2.365h244.373a2.365 2.365 0 0 0 2.365-2.365V45.504a2.365 2.365 0 0 0-2.365-2.366Zm-244.373-.724a3.09 3.09 0 0 0-3.09 3.09v12.648a3.09 3.09 0 0 0 3.09 3.09h244.373a3.09 3.09 0 0 0 3.089-3.09V45.504a3.09 3.09 0 0 0-3.089-3.09H13.314Z",
    clipRule: "evenodd",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.34,
    filter: "url(#empty-redemption_svg__i)",
    opacity: 0.61,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M10.225 80.262a3.09 3.09 0 0 1 3.09-3.09h95.199a3.09 3.09 0 0 1 3.09 3.09V92.91a3.09 3.09 0 0 1-3.09 3.09h-95.2a3.09 3.09 0 0 1-3.09-3.09V80.262Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__j)",
    d: "M10.225 80.262a3.09 3.09 0 0 1 3.09-3.09h95.199a3.09 3.09 0 0 1 3.09 3.09V92.91a3.09 3.09 0 0 1-3.09 3.09h-95.2a3.09 3.09 0 0 1-3.09-3.09V80.262Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-redemption_svg__k)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__l)",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M108.514 77.897h-95.2a2.366 2.366 0 0 0-2.365 2.365V92.91a2.366 2.366 0 0 0 2.365 2.366h95.2a2.366 2.366 0 0 0 2.366-2.366V80.262a2.366 2.366 0 0 0-2.366-2.365Zm-95.2-.725a3.09 3.09 0 0 0-3.09 3.09V92.91a3.09 3.09 0 0 0 3.09 3.09h95.2a3.09 3.09 0 0 0 3.09-3.09V80.262a3.09 3.09 0 0 0-3.09-3.09h-95.2Z",
    clipRule: "evenodd",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.34,
    filter: "url(#empty-redemption_svg__m)",
    opacity: 0.61,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M121.742 80.262a3.09 3.09 0 0 1 3.09-3.09h30.027a3.09 3.09 0 0 1 3.09 3.09V92.91a3.09 3.09 0 0 1-3.09 3.09h-30.027a3.09 3.09 0 0 1-3.09-3.09V80.262Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__n)",
    d: "M121.742 80.262a3.09 3.09 0 0 1 3.09-3.09h30.027a3.09 3.09 0 0 1 3.09 3.09V92.91a3.09 3.09 0 0 1-3.09 3.09h-30.027a3.09 3.09 0 0 1-3.09-3.09V80.262Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-redemption_svg__o)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__p)",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M154.859 77.897h-30.027a2.366 2.366 0 0 0-2.366 2.365V92.91a2.366 2.366 0 0 0 2.366 2.366h30.027a2.366 2.366 0 0 0 2.366-2.366V80.262a2.366 2.366 0 0 0-2.366-2.365Zm-30.027-.725a3.09 3.09 0 0 0-3.09 3.09V92.91a3.09 3.09 0 0 0 3.09 3.09h30.027a3.09 3.09 0 0 0 3.09-3.09V80.262a3.09 3.09 0 0 0-3.09-3.09h-30.027Z",
    clipRule: "evenodd",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.34,
    filter: "url(#empty-redemption_svg__q)",
    opacity: 0.61,
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M10.225 11.09A3.09 3.09 0 0 1 13.315 8H36.1a3.09 3.09 0 0 1 3.09 3.09v12.648a3.09 3.09 0 0 1-3.09 3.09H13.314a3.09 3.09 0 0 1-3.09-3.09V11.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__r)",
    d: "M10.225 11.09A3.09 3.09 0 0 1 13.315 8H36.1a3.09 3.09 0 0 1 3.09 3.09v12.648a3.09 3.09 0 0 1-3.09 3.09H13.314a3.09 3.09 0 0 1-3.09-3.09V11.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-redemption_svg__s)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty-redemption_svg__t)",
    fillOpacity: 0.42,
    fillRule: "evenodd",
    d: "M36.1 8.724H13.314a2.366 2.366 0 0 0-2.365 2.366v12.648a2.365 2.365 0 0 0 2.365 2.365H36.1a2.365 2.365 0 0 0 2.366-2.365V11.09A2.366 2.366 0 0 0 36.1 8.724ZM13.314 8a3.09 3.09 0 0 0-3.09 3.09v12.648a3.09 3.09 0 0 0 3.09 3.09H36.1a3.09 3.09 0 0 0 3.09-3.09V11.09A3.09 3.09 0 0 0 36.1 8H13.314Z",
    clipRule: "evenodd",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__b",
    x1: 105.811,
    x2: 106.85,
    y1: 8,
    y2: 29.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__d",
    x1: 105.811,
    x2: 107.584,
    y1: 8,
    y2: 30.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__f",
    x1: 135.5,
    x2: 135.994,
    y1: 42.414,
    y2: 63.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__h",
    x1: 135.5,
    x2: 136.345,
    y1: 42.414,
    y2: 65.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__j",
    x1: 60.914,
    x2: 62.13,
    y1: 77.172,
    y2: 98.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__l",
    x1: 60.914,
    x2: 62.986,
    y1: 77.172,
    y2: 99.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__n",
    x1: 139.846,
    x2: 143.174,
    y1: 77.172,
    y2: 97.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__p",
    x1: 139.846,
    x2: 145.34,
    y1: 77.172,
    y2: 98.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__r",
    x1: 24.707,
    x2: 28.809,
    y1: 8,
    y2: 28.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty-redemption_svg__t",
    x1: 24.707,
    x2: 31.349,
    y1: 8,
    y2: 28.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__a",
    width: 139.034,
    height: 39.103,
    x: 36.294,
    y: 0.759,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__c",
    width: 139.034,
    height: 39.103,
    x: 36.294,
    y: 0.759,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__e",
    width: 270.827,
    height: 39.103,
    x: 0.087,
    y: 35.172,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__g",
    width: 270.827,
    height: 39.103,
    x: 0.087,
    y: 35.172,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__i",
    width: 121.655,
    height: 39.103,
    x: 0.087,
    y: 69.931,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__k",
    width: 121.655,
    height: 39.103,
    x: 0.087,
    y: 69.931,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__m",
    width: 56.483,
    height: 39.103,
    x: 111.604,
    y: 69.931,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__o",
    width: 56.483,
    height: 39.103,
    x: 111.604,
    y: 69.931,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__q",
    width: 49.241,
    height: 39.103,
    x: 0.087,
    y: 0.759,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty-redemption_svg__s",
    width: 49.241,
    height: 39.103,
    x: 0.087,
    y: 0.759,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.897
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2827_19175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2827_19175",
    result: "shape"
  })))));
};
export default SvgEmptyRedemption;